import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { VideoFormAtomProps } from "../VideoForm.types";

const TitleField = ({ control }: VideoFormAtomProps) => {
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name="title"
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <Input
          value={value}
          onChange={onChange}
          label={t("Title")}
          placeholder={t("Enter title")}
          errorMessage={error?.message}
          maxLength={50}
          data-testid="video--title"
        />
      )}
    />
  );
};

export default TitleField;
